import React from "react";
import { BrowserRouter } from "react-router-dom";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
import { base_path } from "./environment.jsx";
import "../src/style/css/feather.css";
import "../src/style/css/line-awesome.min.css";
import "../src/style/icons/tabler-icons/webfont/tabler-icons.css";
import "../src/style/scss/main.scss";
import "../src/customStyle.scss";
import "../src/style/icons/fontawesome/css/fontawesome.min.css";
import "../src/style/icons/fontawesome/css/all.min.css";
import "../src/style/fonts/feather/css/iconfont.css";
// import "../src/feature-module/components/antdstyle.css";
import { createRoot } from "react-dom/client";
import "./i18n"; // Import the i18n config
import { Provider } from "react-redux";
import store from "./core/redux/store.jsx";
import App from "./App.jsx";
import AuthWrapper from "./components/AuthWrapper.jsx";
import { ConfigProvider } from "antd";
//import { register as registerServiceWorker } from './serviceWorkerRegistration';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const rootElement = document.getElementById("root");

if (rootElement) {
  const root = createRoot(rootElement);
  root.render(
    <React.StrictMode>
      <AuthWrapper>
        <Provider store={store}>
          <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true, }} basename={base_path}>
            <ConfigProvider
              theme={{
                token: {
                 colorPrimary: "#663399", 
                  colorInfo: "#CC6666",      // Tablineo.com secondary light beige
                  colorLink: "#663399",      // Link color
                  colorLinkHover: "#C04478", // Link hover color
                  fontFamily: "'Nunito', sans-serif",
                },
              }}
            >
              <App />
            </ConfigProvider>
          </BrowserRouter>
        </Provider>
      </AuthWrapper>
    </React.StrictMode>
  );
} else {
  console.error("Element with id 'root' not found.");
}

//registerServiceWorker();
serviceWorkerRegistration.register({
  onUpdate: () => {
    const shouldReload = window.confirm(
      'Une nouvelle version est disponible. Recharger maintenant ?'
    );

    if (shouldReload) {
      window.location.reload();
    }
  },
});